export default __webpack_public_path__ + "static/media/check.550d2e53.svg";